import type { Random } from '../core/Random';
import type { IconToken } from '../icons/index';

export interface TvShow {
  id: string;
  channel: string;
  title: string;
  icon: IconToken;
  /** Only available with the satellite dish. */
  dish?: boolean;
  scenes: (rng: Random) => string[];
}

export const TV_SHOWS: readonly TvShow[] = [
  {
    id: 'murray',
    channel: 'CH 4',
    title: 'THE MURRAY SHOW',
    icon: ':dna:',
    scenes: (rng) => {
      const topic = rng.pick([
        "You Slept With My Cousin's Mechanic!",
        'My Boyfriend Is Dating My Mama (Again)!',
        'He Says the Baby Looks Like the Mailman!',
      ]);
      const who = rng.pick(['Duane', 'Cody', 'Travis', 'Bobby Ray']);
      const isFather = rng.chance(0.3);
      return [
        `Today's topic: "${topic}"`,
        `Brandi swears ${who} is the father. ${who} has been "workin' out" in the parking lot all morning.`,
        'The crowd chants. Somebody throws a shoe. Security is just one guy named Steve.',
        'Murray slowly opens the envelope...',
        isFather
          ? `"${who.toUpperCase()}... you ARE the father!" ${who} faints into a potted fern.`
          : `"${who.toUpperCase()}... you are NOT the father!" ${who} does a victory lap around the stage.`,
      ];
    },
  },
  {
    id: 'badge',
    channel: 'CH 6',
    title: 'BADGE BOYZ: Panhandle',
    icon: ':siren:',
    scenes: (rng) => [
      '(reggae music intensifies)',
      `A shirtless suspect flees on foot. He is wearing one ${rng.pick(['boot', 'Croc', 'flip-flop'])}.`,
      'He attempts to hide in a kiddie pool. It is not deep enough. It was never going to be deep enough.',
      '"I AIN\'T DONE NOTHIN\'!" he yells. He has, in fact, done something.',
    ],
  },
  {
    id: 'nascar',
    channel: 'CH 9',
    title: 'NASCAR: Turn Left 500',
    icon: ':checkered-flag:',
    scenes: (rng) => [
      `Lap ${rng.int(40, 180)} of 200. They are turning left.`,
      'Still turning left.',
      'Somebody blew a tire. You hear Earl yell through the wall of his trailer.',
      'They turn left again. Beautiful. Truly beautiful.',
    ],
  },
  {
    id: 'swamp',
    channel: 'CH 11',
    title: 'SWAMP KINGS: Gator Season',
    icon: ':gator:',
    scenes: () => [
      "Bubba's got one on the line. It's a big one.",
      'He wrestles it into the boat with his bare hands.',
      'It is a log. The log wins.',
      'Next week: "The Log Strikes Back."',
    ],
  },
  {
    id: 'shopping',
    channel: 'CH 22',
    title: 'HOME SHOPPING HOUR',
    icon: ':eagle:',
    scenes: () => [
      'Tonight only: the Majestic Porcelain Freedom Eagle.',
      'Hand-painted by "artisans." Six easy payments of $49.99.',
      'The phone lines are "blowing up." The host is visibly sweating.',
      'You almost call. You remember lot rent. You do not call. Growth.',
    ],
  },
  {
    id: 'preacher',
    channel: 'CH 31',
    title: "Pastor Jim-Bob's Prosperity Hour",
    icon: ':pray:',
    scenes: () => [
      'Pastor Jim-Bob asks you to plant a $50 "seed of faith."',
      'He says it will return a hundredfold.',
      'His private jet needs new leather seats, he mentions, unrelated.',
      'You feel strangely compelled. You resist. Barely.',
    ],
  },
  {
    id: 'mawmaw',
    channel: 'CH 14',
    title: "Cookin' with Mee-Maw",
    icon: ':casserole:',
    scenes: () => [
      "Today's recipe: Funeral Potatoes.",
      'Step one: a stick of butter.',
      'Step two: another stick of butter.',
      'Step three: crushed corn flakes. Trust the process.',
    ],
  },
  {
    id: 'wrestling',
    channel: 'SAT 212',
    title: 'FRIDAY NIGHT SLAM',
    icon: ':wrestlers:',
    dish: true,
    scenes: () => [
      'The Mortician vs. Big Tex in a HELL IN A SHED match.',
      'A folding chair enters the chat.',
      'Big Tex hits his finishing move: "The Foreclosure."',
      'You stand up and yell at the TV. Earl yells back through the wall. Bonding.',
    ],
  },
  {
    id: 'novela',
    channel: 'SAT 340',
    title: 'PASIÓN EN LA HACIENDA',
    icon: ':rose:',
    dish: true,
    scenes: () => [
      'A man slaps another man with a leather glove.',
      'A woman reveals she is secretly her own twin.',
      'Dramatic zoom. Dramatic zoom. Dramatic zoom.',
      "You don't speak Spanish but you are FULLY invested.",
    ],
  },
  {
    id: 'weather',
    channel: 'SAT 77',
    title: 'Storm Chaser Chet',
    icon: ':tornado:',
    dish: true,
    scenes: () => [
      'Chet has taken off his jacket. Folks, this is serious.',
      'Tornado watch for the following counties: all of them.',
      'Chet recommends a bathtub and a mattress.',
      'Earl recommends a cooler and a lawn chair.',
    ],
  },
];

export function pickShow(rng: Random, hasDish: boolean): TvShow {
  const pool = TV_SHOWS.filter((s) => hasDish || !s.dish);
  return rng.pick(pool);
}
